export default __webpack_public_path__ + "static/media/Play_to_earn.fcb9cbf5.png";